// src/services/axiosInstance.js
import axios from "axios";
import { BASE_URL } from "../../config";

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: BASE_URL, // Set your base URL
  withCredentials: true, // Ensure cookies are sent with requests
});

// const navigateToHome = () => {
//   const navigate = useNavigate();
//   navigate("/");
// };

// Response interceptor to handle 401 errors
axiosInstance.interceptors.response.use(
  (response) => response, // If response is successful, return it
  async (error) => {
    console.log("error -- in interceptor", error);

    if (error.response && error.response.status === 401) {
      // Clear local storage
      localStorage.clear();
      // await navigate("/");

      // Redirect to base URL
      window.location.href = "/"; // Or you can use history.push('/') if using react-router

      // Optionally return a rejected promise to halt further processing
      return Promise.reject(error);
    }

    return Promise.reject(error); // For any other error, reject the promise
  }
);

export default axiosInstance;
